import { socialLinks } from '../data'
import logo from '../images/logo.svg'
import PageLinks from './PageLinks'
import SocialLink from './SocialLink'
const Navbar = () => {
    return (
        <nav className="navbar">
            <div className="nav-center">
                <div className="nav-header">
                    <img src={logo} className="nav-logo" alt="backroads" />
                    <button type="button" className="nav-toggle" id="nav-toggle">
                        <i className="fas fa-bars"></i>
                    </button>
                </div>
                <PageLinks parentClass={'nav-links'} itemClass={'nav-link'} />
                {/* <ul className="nav-links" id="nav-links">
                    {pageLinks.map((link) => {
                        const { id, href, text } = link
                        return (
                            <li href={href} className='nav-link' key={id}>{text}</li>
                        )
                    })}
                </ul> */}

                <ul className="nav-icons">
                    {socialLinks.map((social) => {
                        return (
                            <SocialLink key={social.id} {...social} itemClass={"nav-icon"} />
                        )
                    })}
                </ul>
            </div>
        </nav>
    )
}

export default Navbar